import { useSearchCardsContext } from '@sorare/core/src/contexts/searchCards';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { useRemoveMarketFilterChipEvent } from 'hooks/events/useRemoveMarketFilterChipEvent';
import { useFormatFilterWidgetValue } from 'hooks/search/useFormatFilterWidgetValue';

import { FilterChip } from '../FilterChip';

export const VirtualToggleActiveFilters = ({
  setVirtualToggleFilters,
}: {
  setVirtualToggleFilters: (virtualToggle: {
    [name: string]: string | string[] | boolean | undefined;
  }) => void;
}) => {
  const {
    favoriteFilter,
    notInLineUpFilter,
    hasCollectibleFilter,
    nonPlayableCards,
    legend,
    leagueFilter,
    promotion,
    customDecksFilter,
    gameweekFilter,
    probablePitchersFilter,
  } = useSearchCardsContext();
  const trackRemoveMarketFilterChip = useRemoveMarketFilterChipEvent();
  const { formatFilterWidgetValue } = useFormatFilterWidgetValue();
  const { sport } = useSportContext();

  const virtualToggleFilters = [
    {
      filter: VIRTUAL_TOGGLE_FILTERS.gameweekFilter,
      condition: gameweekFilter,
      value: gameweekFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.probablePitchersFilter,
      condition: probablePitchersFilter,
      value: probablePitchersFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.favoriteFilter,
      condition: false,
      value: favoriteFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.notInLineupFilter,
      condition: notInLineUpFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.nonPlayableCardsFilter,
      condition: hasCollectibleFilter && nonPlayableCards,
      value: nonPlayableCards,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.legendFilter,
      condition: hasCollectibleFilter && legend,
      value: legend,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.leagueFilter,
      condition: leagueFilter,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.promotedCardsFilter,
      condition: promotion,
    },
    {
      filter: VIRTUAL_TOGGLE_FILTERS.customDecksFilter,
      condition: customDecksFilter,
    },
  ];

  return (
    <>
      {virtualToggleFilters
        .filter(({ condition }) => !!condition)
        .map(virtualToggle => {
          const labels = formatFilterWidgetValue(virtualToggle.filter);
          return labels.map(label => (
            <FilterChip
              key={label}
              label={label}
              onClose={() => {
                setVirtualToggleFilters({
                  [virtualToggle.filter.name]:
                    virtualToggle.filter.defaultValue,
                });
                if (sport) {
                  trackRemoveMarketFilterChip(
                    virtualToggle.filter.trackingName,
                    virtualToggle.value?.toString() || label,
                    sport
                  );
                }
              }}
            />
          ));
        })}
    </>
  );
};
